{
  "title": "Учётные данные устройств",
  "addPassword": "Добавить пароль",
  "emptyTitle": "Паролей пока нет",
  "emptyHint": "Пароль VNC заводится здесь один раз и привязывается к машинам ссылкой: в парке, где на всех машинах один пароль, иначе получилась бы сотня копий одного секрета.",
  "listFailed": "Список недоступен",
  "deleteFailed": "Удалить не удалось",
  "editTitle": "Изменить название, пользователя или секрет",
  "deleteTitle": "Удалить учётные данные",
  "detachFirst": "Сначала отвяжите их от узлов — иначе подключение сломалось бы молча",
  "noVncHint": "Паролей VNC пока нет. Заведите их на экране «Учётные данные» — оттуда они привязываются сразу ко всем машинам с одинаковым паролем.",
  "noSshHint": "Учётных данных SSH пока нет. Заведите их на экране «Учётные данные» — пароль или приватный ключ, — оттуда они привязываются сразу ко всем машинам с одинаковым доступом.",
  "noRtspHint": "Учётных данных вида RTSP пока нет. Заведите их на экране «Учётные данные» — там же, где пароли VNC, — и привяжите отсюда.",
  "kind": {
    "vnc": "VNC",
    "rtsp": "RTSP (камеры)",
    "snmp": "SNMP",
    "httpBasic": "HTTP Basic",
    "ssh": "SSH (пароль)",
    "sshKey": "SSH (приватный ключ)"
  },
  "hint": {
    "password": "пароль",
    "community": "сообщество",
    "privateKey": "приватный ключ"
  },
  "column": {
    "username": "Пользователь",
    "nodes": "Узлов",
    "createdAt": "Заведены"
  },
  "form": {
    "nameHint": "Как отличать эти данные от других: «Пароль парка», «Камеры филиала»",
    "kindFixed": "Вид не меняется: он определяет, как используется секрет, и смена сломала бы подключения привязанных узлов",
    "usernameHint": "У VNC Authentication имени пользователя нет",
    "secret": "Секрет",
    "newSecret": "Новый секрет",
    "leaveEmpty": "оставьте пустым, чтобы не менять",
    "vncTruncatedHint": "Сервер проверит только первые восемь символов: так устроен протокол VNC. Всё, что дальше, на вход не влияет.",
    "keepSecretHint": "Пустое поле оставит прежний секрет. Прочитать записанное нельзя — только заменить целиком",
    "newSecretHint": "Записывается зашифрованным и больше не показывается — только заменяется целиком",
    "vncTruncatedNote": "Пароль длиннее {{limit}} символов. VNC Authentication шифрует вызов ключом из первых восьми байт, остальные отбрасывает: подключение пройдёт и с неполным паролем, и надёжности длина здесь не добавляет."
  },
  "none": "без пароля",
  "fieldLabel": "Учётные данные"
}
